import consumer from "./consumer"

class ChatChannel {
  constructor(sessionId, callbacks = {}) {
    this.sessionId = sessionId
    this.callbacks = callbacks
    this.subscription = null
  }

  connect() {
    const callbacks = this.callbacks
    const sessionId = this.sessionId
    
    this.subscription = consumer.subscriptions.create(
      {
        channel: "ChatChannel",
        session_id: sessionId
      },
      {
        connected() {
          if (callbacks.onConnected) {
            callbacks.onConnected()
          }
        },

        disconnected() {
          if (callbacks.onDisconnected) {
            callbacks.onDisconnected()
          }
        },

        received(data) {
          if (data.type === 'connected') {
            if (callbacks.onSessionId) {
              callbacks.onSessionId(data.session_id)
            }
          } else if (data.role === 'assistant' || data.role === 'user') {
            if (callbacks.onMessage) {
              callbacks.onMessage(data)
            }
          }
        }
      }
    )

    return this.subscription
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
  }

  sendMessage(content) {
    if (this.subscription) {
      this.subscription.send({
        session_id: this.sessionId,
        content: content
      })
    }
  }
}

export default ChatChannel

